import type { FeatureCollection } from 'geojson';

import { apiClient } from './apiClient';
import { normaliseFeatureCollectionResponse } from './geoJsonUtils';

/**
 * Fetches all pipeline features within the given viewport from the backend.
 * Uses GET /waterpipelines/md/{bbox} (WaterPipelinesModule policy: Savi or LeakDetection).
 *
 * bbox format: "minLng,minLat,maxLng,maxLat" — matches BoundingBox.TryParse.
 * The bbox is URL-encoded as a path segment (commas → %2C).
 *
 * Passes clientId as a query parameter so the ExternalAPI can scope the response
 * to the selected client rather than the caller's JWT claim client (Origin users).
 */
export async function fetchPipelinesForViewport(clientId: string, bbox: string): Promise<FeatureCollection> {
    const encodedBbox = encodeURIComponent(bbox);
    const response = await apiClient.get<unknown>(`/waterpipelines/md/${encodedBbox}`, { params: { clientId } });
    return normaliseFeatureCollectionResponse(response.data);
}
